var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teaching"},[_c('h1',{staticClass:"view-title"},[_vm._v("Teaching")]),_vm._l((_vm.courses),function(course){return _c('div',{key:course.id},[_c('Course',{attrs:{"course":course}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }